"use client";

import { c as _c } from "react/compiler-runtime";
import { CTable, CTableBody, CTableCaption, CTableDataCell, CTableFoot, CTableHead, CTableHeaderCell, CTableRow } from "@coreui/react";
import type { ComponentProps } from "react";
export type TableRootProps = ComponentProps<typeof CTable> & {
  size?: "sm" | "md";
};
function Root(t0) {
  const $ = _c(7);
  let className;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
  }
  const t1 = `${size === "sm" ? "table-sm" : ""} ${className ?? ""}`;
  let t2;
  if ($[4] !== props || $[5] !== t1) {
    t2 = <CTable align="middle" borderless={true} hover={true} responsive={true} className={t1} {...props} />;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export const Table = {
  Root,
  Body: CTableBody,
  Caption: CTableCaption,
  Cell: CTableDataCell,
  Foot: CTableFoot,
  Head: CTableHead,
  Header: CTableHeaderCell,
  Row: CTableRow
};